import { render } from "./AuthorTable.vue?vue&type=template&id=431bfd18"
import script from "./AuthorTable.vue?vue&type=script&lang=ts"
export * from "./AuthorTable.vue?vue&type=script&lang=ts"
script.render = render

export default script